// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../../../../../node_modules/@glennsl/bs-json/src/Json.bs.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../Config.bs.js";
import * as CrmNetwork from "../../../../library/network/CrmNetwork.bs.js";
import * as CountryConfig from "../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CreateCustomerRepoConfig from "./CreateCustomerRepoConfig.bs.js";
import * as CreateCustomerPayloadMapper from "../entity-mapper/CreateCustomerPayloadMapper.bs.js";
import * as CreateCusomerPayloadApiModel from "../api-model/CreateCusomerPayloadApiModel.bs.js";

function createCustomer(customer, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/crm/create_customer_v2";
  var payload = Json.stringify(CreateCusomerPayloadApiModel.t_encode(CreateCustomerPayloadMapper.execute(customer)));
  return CrmNetwork.post(requestUrl, undefined, {
                country: CountryConfig.countryToString(country)
              }, payload, undefined, /* Include */2, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CreateCustomerRepoConfig.CreateCustomerResponseConveror.execute, result);
                        });
            });
}

var CreateCustomerRepo = {
  createCustomer: createCustomer
};

export {
  CreateCustomerRepo ,
  
}
/* Config Not a pure module */
